module.exports = __webpack_public_path__ + "media/images/common-nav/free-camping/florida-f9be851149f4708203003cb0bf4b90cf.jpg";